'use client';

import { raptiveAdManager } from '@benzinga/ads-utils';
import type { RouteMetaPayload } from './routeMeta';

export function applyRouteMetaTargeting(payload: RouteMetaPayload): void {
  raptiveAdManager.configure({ targeting: payload.pageTargeting ?? {} });
  raptiveAdManager.configure({ footerDisabled: payload.disableRaptiveFooter ?? false });
}
